<template>
  <div id="app">
    <div class="container">
      <header class="header">
        <a href="/#/">
          <img alt src="/static/images/logo.png">
        </a>
      </header>
      <main-menu v-if="is_logged_in && show_menu"></main-menu>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import MainMenu from './components/Menu.vue';
import * as AuthService from './services/auth.service';

export default {
  name: 'app',
  components: {
    MainMenu,
  },

  data() {
    return {
      is_logged_in: AuthService.isLoggedin(),
      show_menu: true,
      api_key: process.env.API_KEY,
    };
  },
  mounted() {
    this.is_logged_in = AuthService.isLoggedin();
    this.show_menu = this.$route.name !== 'Signin';
  },
  watch: {
    $route: function(val, changes) {
      this.show_menu = val.name !== 'Signin';
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/app.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?37ebeb2b